"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibleForAnnualCoverBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PromotionContributionSection_1 = require("./PromotionContributionSection");
var journey_services_1 = require("@ferry/journey-services");
var portal_core_1 = require("@ferry/portal-core");
var EligibleForAnnualCoverBanner = /** @class */ (function (_super) {
    __extends(EligibleForAnnualCoverBanner, _super);
    function EligibleForAnnualCoverBanner(props) {
        return _super.call(this, props) || this;
    }
    EligibleForAnnualCoverBanner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: this.getGreatNewsWording() }), "Before you proceed with your 5-Day Drive Away cover, why not explore the benefits of our annual cover.", (0, jsx_runtime_1.jsx)("div", { className: "font-weight-bold", children: (0, jsx_runtime_1.jsx)(PromotionContributionSection_1.PromotionsContributionSection, { interaction: this.props.interaction }) })] }) }));
    };
    EligibleForAnnualCoverBanner.prototype.getGreatNewsWording = function () {
        var tieredFactors = this.props.interaction.tieredFactors;
        if (tieredFactors.length > 1 || (tieredFactors.length == 1 && tieredFactors[0].tier == journey_services_1.ALLIANZ)) {
            return "Great news! You’re also eligible for our annual car insurance. ";
        }
        else if (tieredFactors.length == 1 && tieredFactors[0].tier == journey_services_1.ALLIANZ_ESSENTIALS) {
            return "Great news! You’re also eligible for our annual car insurance that covers the basics. ";
        }
        return "";
    };
    return EligibleForAnnualCoverBanner;
}(plugin_journey_1.WidgetBase));
exports.EligibleForAnnualCoverBanner = EligibleForAnnualCoverBanner;
//# sourceMappingURL=EligibleForAnnualCoverBanner.js.map